module.exports = __webpack_public_path__ + "img/upgrade-btn.8cdbf8fd.png";